import { Sender } from 'xstate';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import { globalAppService } from '../app.xstate';

export const initFeatureFlags =
  (_ctx: ProStudioContext, _event: ProStudioEvents) =>
  async (sendEvent: Sender<ProStudioEvents>) => {
    globalAppService.subscribe(async (state) => {
      const globalContext = state?.context;

      if (!globalContext) return;

      const { featureFlags } = globalContext;

      sendEvent({
        type: 'setFeatureFlags',
        values: featureFlags,
      });
    });
  };
